<template>
  <img src="/images/ankle.png">
</template>

<script>
  export default {
    name: "Ankle",
  }
</script>
